import { useQuery } from '@tanstack/react-query';
import { getMunicipalitiesOptions } from '@citylytics/core-api-ts-client/react-query';
import { LIST_PAGE_MAX_SIZE } from '@citylytics/http/constants';
import { readWholeList } from '../core-api-client/core-api-client.utils.js';
/**
 * Every municipality by name, read whole, for naming them or picking one; empty while disabled.
 * Past one page it throws rather than quietly leaving municipalities out of a picker: that is the
 * point to page through them, or search. `enabled` is the caller's: the route is staff-only.
 */
export function useMunicipalitiesLookup(params) {
    const municipalities = useQuery({
        ...getMunicipalitiesOptions({ query: { page: 1, size: LIST_PAGE_MAX_SIZE, sort: ['name'] } }),
        enabled: params.enabled,
    });
    return readWholeList({
        items: municipalities.data?.data.municipalities,
        hasMore: municipalities.data?.data.pagination.hasMore,
        listName: 'municipalities',
    });
}
